import { render, staticRenderFns } from "./SmashEggs.vue?vue&type=template&id=fac6449c&scoped=true"
import script from "./SmashEggs.vue?vue&type=script&lang=js"
export * from "./SmashEggs.vue?vue&type=script&lang=js"
import style0 from "./SmashEggs.vue?vue&type=style&index=0&id=fac6449c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6449c",
  null
  
)

export default component.exports